import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import { FullImageSection } from '@/components/Layouts'
import { getImageData } from '@/utilites/getImageData'

interface Content {
    title?: string
    subtitle?: string
    image?: string
    backgroundPosition?: string
}

interface S3_L2_1Props {
    content?: Content
    blockName?:string
}

const Index = (props: S3_L2_1Props) => {
    const { content = {} } = props
    const { title = '', subtitle = '', image, backgroundPosition } = content
    const heroImage = getImageData(image)
    return (
        <FullImageSection
            aria-label='S3_L2_1'
            image={heroImage.src}
            height={{ xs: '60vh', md: '70vh' }}
            backgroundPosition={backgroundPosition}
            
        >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    flexDirection: 'column',
                    gap: 3,
                    width: {
                        xs: '90vw',
                        md: '60vw',
                        lg: '40vw',
                    },
                }}
            >
                <Typography
                    variant='h1'
                    color='white'
                >
                    {title}
                </Typography>
                <Typography
                    variant='body2'
                    color='white'
                >
                    {subtitle}
                </Typography>
            </Box>
        </FullImageSection>
    )
}

export default Index
